import React from 'react';

export const CenterLayout: React.FC = ({ children }) => {
  return <div className="basic__center-layout basic__center-desktop-wrapper">{children}</div>;
};
